import { getWeek as getWeekFns } from 'date-fns';

export default function getWeek(date: Date, sundayStart: boolean): number {
  const weekStartsOn = sundayStart ? 0 : 1;
  return getWeekFns(date, { weekStartsOn });
}
